import {
  UpdateEventActiveStateResponse,
  updateEventActiveStateMutation,
  updateEventActiveStateDttMutation,
} from '@marriott/mi-groups-graphql';
import { useMutationTransformer } from '../../../hooks';

type UpdateEventActiveState = {
  groupsReslinkUpdateStatus: UpdateEventActiveStateResponse;
};

type UpdateEventActiveStateDtt = {
  sales: {
    groupSales: {
      groupManagement: {
        updateActiveStatusOfReslink: UpdateEventActiveStateResponse;
      };
    };
  };
};

export const useUpdateEventActiveState = () => {
  return useMutationTransformer<UpdateEventActiveState, UpdateEventActiveStateDtt>({
    currentMutation: updateEventActiveStateMutation,
    dttMutation: updateEventActiveStateDttMutation,
    onTransform: data => {
      return {
        sales: {
          groupSales: {
            groupManagement: {
              updateActiveStatusOfReslink: data.groupsReslinkUpdateStatus,
            },
          },
        },
      };
    },
  });
};
